export const samplesPathsSegments = {
    samples: 'samples',
    upload: 'upload',
    editor: 'editor'
};

export const samplesPaths = {
    upload: '/' + samplesPathsSegments.samples + '/' + samplesPathsSegments.upload,
    editor: '/' + samplesPathsSegments.samples + '/' + samplesPathsSegments.editor
};
